/* WATCHERS V2 COLLECTION RUNTIME — extracted from C49, singleton guards preserved. */

(() => {
  if (window.__WATCHERS_INLINE_FACET_ACCORDION__) return;
  window.__WATCHERS_INLINE_FACET_ACCORDION__ = true;

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  function isMainFacetSummary(summary) {
    if (!summary || !summary.matches('.mobile-facets__summary')) return false;
    const details = summary.closest('.mobile-facets__details');
    if (!details) return false;
    const main = details.parentElement;
    return !!main && main.classList.contains('mobile-facets__main');
  }

  /*
    Dawn normally uses these summary clicks to slide to another facet screen.
    Capture the click first and make it a normal inline accordion instead.
  */
  document.addEventListener('click', (event) => {
    if (!isMobile()) return;

    const summary = event.target.closest('.mobile-facets__summary');
    if (!isMainFacetSummary(summary)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const details = summary.closest('.mobile-facets__details');
    const willOpen = !details.hasAttribute('open');

    if (willOpen) {
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    } else {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }
  }, true);

  /* Clear any slide-screen classes Dawn may have left behind. */
  document.addEventListener('click', (event) => {
    if (!isMobile()) return;
    if (!event.target.closest('.mobile-facets__summary')) return;

    requestAnimationFrame(() => {
      document.querySelectorAll('.mobile-facets__submenu.menu-opening').forEach((submenu) => {
        submenu.classList.remove('menu-opening');
      });
    });
  });
})();

(() => {
  if (window.__WATCHERS_LEAGUE_TEAM_RUNTIME__) return;
  window.__WATCHERS_LEAGUE_TEAM_RUNTIME__ = true;

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  const leagueTeams = {
    MLB: new Set([
      'ARIZONA DIAMONDBACKS','ATHLETICS','OAKLAND ATHLETICS','ATLANTA BRAVES','BALTIMORE ORIOLES',
      'BOSTON RED SOX','CHICAGO CUBS','CHICAGO WHITE SOX','CINCINNATI REDS','CLEVELAND GUARDIANS',
      'COLORADO ROCKIES','DETROIT TIGERS','HOUSTON ASTROS','KANSAS CITY ROYALS','LOS ANGELES ANGELS',
      'ANAHEIM ANGELS','LOS ANGELES DODGERS','MIAMI MARLINS','MILWAUKEE BREWERS','MINNESOTA TWINS',
      'NEW YORK METS','NEW YORK YANKEES','PHILADELPHIA PHILLIES','PITTSBURGH PIRATES','SAN DIEGO PADRES',
      'SAN FRANCISCO GIANTS','SEATTLE MARINERS','ST. LOUIS CARDINALS','ST LOUIS CARDINALS','TAMPA BAY RAYS',
      'TEXAS RANGERS','TORONTO BLUE JAYS','WASHINGTON NATIONALS'
    ]),
    NBA: new Set([
      'ATLANTA HAWKS','BOSTON CELTICS','BROOKLYN NETS','CHARLOTTE HORNETS','CHICAGO BULLS',
      'CLEVELAND CAVALIERS','DALLAS MAVERICKS','DENVER NUGGETS','DETROIT PISTONS','GOLDEN STATE WARRIORS',
      'HOUSTON ROCKETS','INDIANA PACERS','LOS ANGELES CLIPPERS','LA CLIPPERS','LOS ANGELES LAKERS','LA LAKERS',
      'MEMPHIS GRIZZLIES','MIAMI HEAT','MILWAUKEE BUCKS','MINNESOTA TIMBERWOLVES','NEW ORLEANS PELICANS',
      'NEW YORK KNICKS','OKLAHOMA CITY THUNDER','ORLANDO MAGIC','PHILADELPHIA 76ERS','PHOENIX SUNS',
      'PORTLAND TRAIL BLAZERS','SACRAMENTO KINGS','SAN ANTONIO SPURS','TORONTO RAPTORS','UTAH JAZZ',
      'WASHINGTON WIZARDS'
    ]),
    NFL: new Set([
      'ARIZONA CARDINALS','ATLANTA FALCONS','BALTIMORE RAVENS','BUFFALO BILLS','CAROLINA PANTHERS',
      'CHICAGO BEARS','CINCINNATI BENGALS','CLEVELAND BROWNS','DALLAS COWBOYS','DENVER BRONCOS',
      'DETROIT LIONS','GREEN BAY PACKERS','HOUSTON TEXANS','INDIANAPOLIS COLTS','JACKSONVILLE JAGUARS',
      'KANSAS CITY CHIEFS','LAS VEGAS RAIDERS','LOS ANGELES CHARGERS','LA CHARGERS','LOS ANGELES RAMS','LA RAMS',
      'MIAMI DOLPHINS','MINNESOTA VIKINGS','NEW ENGLAND PATRIOTS','NEW ORLEANS SAINTS','NEW YORK GIANTS',
      'NEW YORK JETS','PHILADELPHIA EAGLES','PITTSBURGH STEELERS','SAN FRANCISCO 49ERS','SEATTLE SEAHAWKS',
      'TAMPA BAY BUCCANEERS','TENNESSEE TITANS','WASHINGTON COMMANDERS'
    ]),
    NHL: new Set([
      'ANAHEIM DUCKS','BOSTON BRUINS','BUFFALO SABRES','CALGARY FLAMES','CAROLINA HURRICANES',
      'CHICAGO BLACKHAWKS','COLORADO AVALANCHE','COLUMBUS BLUE JACKETS','DALLAS STARS','DETROIT RED WINGS',
      'EDMONTON OILERS','FLORIDA PANTHERS','LOS ANGELES KINGS','LA KINGS','MINNESOTA WILD','MONTREAL CANADIENS',
      'NASHVILLE PREDATORS','NEW JERSEY DEVILS','NEW YORK ISLANDERS','NEW YORK RANGERS','OTTAWA SENATORS',
      'PHILADELPHIA FLYERS','PITTSBURGH PENGUINS','SAN JOSE SHARKS','SEATTLE KRAKEN','ST. LOUIS BLUES',
      'ST LOUIS BLUES','TAMPA BAY LIGHTNING','TORONTO MAPLE LEAFS','UTAH MAMMOTH','VANCOUVER CANUCKS',
      'VEGAS GOLDEN KNIGHTS','WASHINGTON CAPITALS','WINNIPEG JETS'
    ])
  };

  function cleanText(value) {
    return String(value || '')
      .replace(/\s*\(\d+[\d,]*\)\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  function facetTitle(details) {
    const summary = details?.querySelector(':scope > .mobile-facets__summary');
    if (!summary) return '';
    return cleanText(summary.textContent);
  }

  function findFacet(root, wanted) {
    return Array.from(root.querySelectorAll('.mobile-facets__main > .mobile-facets__details'))
      .find((details) => facetTitle(details) === wanted) || null;
  }

  function selectedLeagueKeys(leagueDetails) {
    if (!leagueDetails) return [];
    const selected = [];
    leagueDetails.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
      const label = input.closest('label') || input.parentElement;
      const name = cleanText(label?.textContent || input.value);
      if (leagueTeams[name]) selected.push(name);
    });
    return selected;
  }

  function teamNameFromItem(item) {
    const label = item.querySelector('label') || item;
    return cleanText(label.textContent);
  }

  function filterTeamsByLeague(root = document) {
    if (!isMobile()) return;

    root.querySelectorAll('.mobile-facets__main').forEach((main) => {
      const leagueDetails = findFacet(main, 'LEAGUE');
      const teamsDetails = findFacet(main, 'TEAMS');
      if (!teamsDetails) return;

      const leagues = selectedLeagueKeys(leagueDetails);
      const teamItems = teamsDetails.querySelectorAll('.mobile-facets__submenu .mobile-facets__item');

      /* No recognized league selected: show every team. */
      if (!leagues.length) {
        teamItems.forEach((item) => { item.hidden = false; });
        return;
      }

      const allowed = new Set();
      leagues.forEach((league) => {
        leagueTeams[league]?.forEach((team) => allowed.add(team));
      });

      teamItems.forEach((item) => {
        const name = teamNameFromItem(item);
        const show = allowed.has(name);
        item.hidden = !show;

        if (!show) {
          const input = item.querySelector('input[type="checkbox"]');
          if (input?.checked) input.checked = false;
        }
      });
    });
  }

  document.addEventListener('change', (event) => {
    if (!isMobile()) return;
    const input = event.target.closest('.mobile-facets__details input[type="checkbox"]');
    if (!input) return;
    const details = input.closest('.mobile-facets__details');
    if (facetTitle(details) !== 'LEAGUE') return;
    filterTeamsByLeague(document);
  });

  document.addEventListener('click', (event) => {
    if (!isMobile()) return;
    const summary = event.target.closest('.mobile-facets__summary');
    if (!summary) return;
    const details = summary.closest('.mobile-facets__details');
    if (facetTitle(details) === 'TEAMS') {
      requestAnimationFrame(() => filterTeamsByLeague(document));
    }
  });

  function boot() {
    filterTeamsByLeague(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  /*
   * C27: Shopify can replace the facet DOM after a selection.
   * Re-apply the league -> team visibility immediately whenever
   * the mobile facet markup is replaced, so TEAMS never flashes
   * the full list before narrowing to the selected league.
   */
  const watchersFacetObserver = new MutationObserver((mutations) => {
    if (!isMobile()) return;

    let facetMarkupChanged = false;

    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (
          node.matches?.('.mobile-facets__main, .mobile-facets__details, #ProductGridContainer') ||
          node.querySelector?.('.mobile-facets__main, .mobile-facets__details')
        ) {
          facetMarkupChanged = true;
          break;
        }
      }
      if (facetMarkupChanged) break;
    }

    if (facetMarkupChanged) {
      filterTeamsByLeague(document);
    }
  });

  watchersFacetObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

(() => {
  if (window.__WATCHERS_PRICE_COVER_RUNTIME__) return;
  window.__WATCHERS_PRICE_COVER_RUNTIME__ = true;

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  const numberValue = (value, fallback = NaN) => {
    const parsed = parseFloat(String(value ?? '').replace(/,/g, ''));
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const formatPrice = (value) => {
    if (!Number.isFinite(value)) return '';
    return Number.isInteger(value) ? String(value) : value.toFixed(2).replace(/\.00$/, '');
  };

  const getPriceDetails = (root = document) => Array.from(
    root.querySelectorAll('.mobile-facets__details')
  ).filter((details) => {
    const summary = details.querySelector(':scope > .mobile-facets__summary');
    const title = String(summary?.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
    return title.startsWith('PRICE');
  });

  const getBackend = (details) => {
    const native = details?.querySelector('[data-watchers-price-native]') ||
      details?.querySelector('.watchers-price-cover-stage__native price-range.facets__price') ||
      details?.querySelector('price-range.facets__price');
    if (!native) return null;
    const fields = Array.from(native.querySelectorAll('input[type="text"], input[type="number"]'))
      .filter((input) => input.name && /price/i.test(input.name));
    if (fields.length < 2) return null;
    return { native, minField: fields[0], maxField: fields[1] };
  };

  const getCover = (details) => details?.querySelector('[data-watchers-price-cover]') || null;

  const priceParamValue = (input) => {
    if (!input?.name) return '';
    return String(new URL(window.location.href).searchParams.get(input.name) || '').trim();
  };

  const contextKey = (minField, maxField) => {
    const url = new URL(window.location.href);
    if (minField?.name) url.searchParams.delete(minField.name);
    if (maxField?.name) url.searchParams.delete(maxField.name);
    url.searchParams.delete('page');
    url.searchParams.delete('sort_by');
    url.searchParams.delete('section_id');
    url.hash='';
    const ordered=Array.from(url.searchParams.entries()).sort(([ak,av],[bk,bv])=>ak===bk?av.localeCompare(bv):ak.localeCompare(bk));
    const params=new URLSearchParams(); ordered.forEach(([k,v])=>params.append(k,v));
    return `watchers-cover-price-bounds:${url.pathname}?${params.toString()}`;
  };

  const readCachedBounds = (key) => {
    try {
      const raw=sessionStorage.getItem(key); if(!raw) return null;
      const p=JSON.parse(raw); const min=Number(p?.min), max=Number(p?.max);
      if(!Number.isFinite(min)||!Number.isFinite(max)||min<=0||max<min) return null;
      return {min,max};
    } catch(_) { return null; }
  };

  const writeCachedBounds = (key,bounds) => {
    if(!bounds||!Number.isFinite(bounds.min)||!Number.isFinite(bounds.max)||bounds.min<=0||bounds.max<bounds.min) return;
    try { sessionStorage.setItem(key,JSON.stringify(bounds)); } catch(_) {}
  };

  const getGridBounds = (fallbackMin,fallbackMax) => {
    const grid=document.querySelector('#product-grid');
    const dataMin=numberValue(grid?.dataset.watchersPriceMin); const dataMax=numberValue(grid?.dataset.watchersPriceMax);
    if(Number.isFinite(dataMin)&&dataMin>0&&Number.isFinite(dataMax)&&dataMax>=dataMin) return {min:dataMin,max:dataMax};
    const values=[];
    document.querySelectorAll('#product-grid .watchers-collection-card__price-sale, #product-grid .watchers-collection-card__price-regular, #product-grid .price-item--sale, #product-grid .price-item--regular').forEach((node)=>{
      if(node.classList.contains('watchers-collection-card__price-compare')||node.closest('.price__compare')) return;
      const m=String(node.textContent||'').replace(/,/g,'').match(/\d+(?:\.\d+)?/g); if(!m?.length) return;
      const v=numberValue(m[m.length-1]); if(Number.isFinite(v)&&v>0) values.push(v);
    });
    if(!values.length) return {min:fallbackMin,max:fallbackMax};
    return {min:Math.min(...values),max:Math.max(...values)};
  };

  const getNaturalBounds = (details,minField,maxField) => {
    const nativeMin=numberValue(minField.getAttribute('min'),0);
    let nativeMax=numberValue(maxField.getAttribute('max'));
    if(!Number.isFinite(nativeMax)||nativeMax<=nativeMin) nativeMax=numberValue(minField.getAttribute('max'));
    if(!Number.isFinite(nativeMax)||nativeMax<=nativeMin) nativeMax=numberValue(getCover(details)?.dataset.watchersPriceRangeMax,1000);
    const active=!!(priceParamValue(minField)||priceParamValue(maxField));
    const key=contextKey(minField,maxField); const cached=readCachedBounds(key); const visible=getGridBounds(nativeMin,nativeMax);
    if(!active){
      const min=Number.isFinite(visible.min)&&visible.min>0?visible.min:nativeMin;
      const max=Math.max(min,Number.isFinite(nativeMax)?nativeMax:min,Number.isFinite(visible.max)?visible.max:min);
      const bounds={min,max}; writeCachedBounds(key,bounds); return bounds;
    }
    if(cached) return cached;
    const min=Number.isFinite(visible.min)&&visible.min>0?visible.min:nativeMin;
    const max=Math.max(min,Number.isFinite(nativeMax)?nativeMax:min,Number.isFinite(visible.max)?visible.max:min);
    return {min,max};
  };

  const emitPriceState = (details,minField,maxField,rangeMin,rangeMax) => {
    document.dispatchEvent(new CustomEvent('watchers:price:state',{detail:{
      active:!!(String(minField?.value||'').trim()||String(maxField?.value||'').trim()),
      minName:minField?.name||'', maxName:maxField?.name||'', minValue:String(minField?.value||''), maxValue:String(maxField?.value||''), rangeMin, rangeMax, details
    }}));
  };

  const bindCover = (details) => {
    if(!isMobile()||!details?.isConnected) return;
    const cover=getCover(details); const backend=getBackend(details); if(!cover||!backend) return;
    const {minField,maxField}=backend;
    const minInput=cover.querySelector('[data-watchers-price-from-input]');
    const maxInput=cover.querySelector('[data-watchers-price-to-input]');
    const minRange=cover.querySelector('.watchers-price-range--min');
    const maxRange=cover.querySelector('.watchers-price-range--max');
    const slider=cover.querySelector('.watchers-price-slider');
    if(!minInput||!maxInput||!minRange||!maxRange||!slider) return;

    const bounds=getNaturalBounds(details,minField,maxField); const rangeMin=bounds.min; const rangeMax=Math.max(bounds.min,bounds.max);
    const step=numberValue(maxField.getAttribute('step'),1)||1;
    [minRange,maxRange].forEach((r)=>{r.min=String(rangeMin);r.max=String(rangeMax);r.step=String(step);r.disabled=false;});

    const initialMin=Math.max(rangeMin,Math.min(numberValue(priceParamValue(minField),rangeMin),rangeMax));
    const initialMax=Math.max(initialMin,Math.min(numberValue(priceParamValue(maxField),rangeMax),rangeMax));
    minRange.value=String(initialMin); maxRange.value=String(initialMax); minInput.value=formatPrice(initialMin); maxInput.value=formatPrice(initialMax);

    const syncVisuals=()=>{
      const min=numberValue(minRange.value,rangeMin), max=numberValue(maxRange.value,rangeMax);
      if(document.activeElement!==minInput) minInput.value=formatPrice(min);
      if(document.activeElement!==maxInput) maxInput.value=formatPrice(max);
      const span=Math.max(rangeMax-rangeMin,1);
      const minPct=((min-rangeMin)/span)*100, maxPct=((max-rangeMin)/span)*100;
      slider.style.setProperty('--watchers-price-min',`${Math.max(0,Math.min(100,minPct))}%`);
      slider.style.setProperty('--watchers-price-max',`${Math.max(0,Math.min(100,maxPct))}%`);
      cover.setAttribute('data-watchers-price-ready','true');
    };

    const commitMin=(value)=>{
      minField.value=value<=rangeMin?'':String(value);
      minField.dispatchEvent(new Event('input',{bubbles:true})); minField.dispatchEvent(new Event('change',{bubbles:true}));
      emitPriceState(details,minField,maxField,rangeMin,rangeMax);
    };
    const commitMax=(value)=>{
      maxField.value=value>=rangeMax?'':String(value);
      maxField.dispatchEvent(new Event('input',{bubbles:true})); maxField.dispatchEvent(new Event('change',{bubbles:true}));
      emitPriceState(details,minField,maxField,rangeMin,rangeMax);
    };

    const applyMinText=()=>{
      let v=numberValue(minInput.value,numberValue(minRange.value,rangeMin));
      v=Math.max(rangeMin,Math.min(v,numberValue(maxRange.value,rangeMax))); minRange.value=String(v); syncVisuals(); commitMin(v);
    };
    const applyMaxText=()=>{
      let v=numberValue(maxInput.value,numberValue(maxRange.value,rangeMax));
      v=Math.min(rangeMax,Math.max(v,numberValue(minRange.value,rangeMin))); maxRange.value=String(v); syncVisuals(); commitMax(v);
    };

    if(cover.dataset.watchersPriceBound!=='true'){
      cover.dataset.watchersPriceBound='true';
      minRange.addEventListener('input',()=>{ if(numberValue(minRange.value)>numberValue(maxRange.value)) minRange.value=maxRange.value; syncVisuals(); });
      maxRange.addEventListener('input',()=>{ if(numberValue(maxRange.value)<numberValue(minRange.value)) maxRange.value=minRange.value; syncVisuals(); });
      minRange.addEventListener('change',()=>commitMin(numberValue(minRange.value,rangeMin)));
      maxRange.addEventListener('change',()=>commitMax(numberValue(maxRange.value,rangeMax)));
      minInput.addEventListener('change',applyMinText); minInput.addEventListener('blur',applyMinText);
      maxInput.addEventListener('change',applyMaxText); maxInput.addEventListener('blur',applyMaxText);

      let activeRange=null;
      const valueFromPointer=(clientX)=>{
        const rect=slider.getBoundingClientRect(); if(!rect.width) return rangeMin;
        const ratio=Math.max(0,Math.min(1,(clientX-rect.left)/rect.width));
        const raw=rangeMin+ratio*(rangeMax-rangeMin); const stepped=Math.round((raw-rangeMin)/step)*step+rangeMin;
        return Math.max(rangeMin,Math.min(rangeMax,stepped));
      };
      const chooseRange=(value)=>{
        const a=numberValue(minRange.value,rangeMin), b=numberValue(maxRange.value,rangeMax);
        const da=Math.abs(value-a), db=Math.abs(value-b); if(da<db) return minRange; if(db<da) return maxRange;
        return value<=(a+b)/2?minRange:maxRange;
      };
      const moveRange=(range,clientX)=>{
        let value=valueFromPointer(clientX);
        if(range===minRange){ value=Math.min(value,numberValue(maxRange.value,rangeMax)); minRange.value=String(value); }
        else { value=Math.max(value,numberValue(minRange.value,rangeMin)); maxRange.value=String(value); }
        syncVisuals();
      };
      slider.addEventListener('pointerdown',(event)=>{
        if(event.pointerType==='mouse'&&event.button!==0) return;
        activeRange=chooseRange(valueFromPointer(event.clientX));
        try{slider.setPointerCapture(event.pointerId);}catch(_){}
        moveRange(activeRange,event.clientX);
      });
      slider.addEventListener('pointermove',(event)=>{
        if(!activeRange) return; if(event.pointerType==='mouse'&&event.buttons===0) return;
        moveRange(activeRange,event.clientX);
      });
      const endDrag=(event)=>{
        if(!activeRange) return; const finished=activeRange;
        try{if(slider.hasPointerCapture(event.pointerId)) slider.releasePointerCapture(event.pointerId);}catch(_){}
        activeRange=null; if(event.type!=='pointerup') return;
        if(finished===minRange) commitMin(numberValue(minRange.value,rangeMin)); else commitMax(numberValue(maxRange.value,rangeMax));
      };
      slider.addEventListener('pointerup',endDrag); slider.addEventListener('pointercancel',endDrag);
    }
    syncVisuals();
  };

  const install=(root=document)=>{ if(!isMobile()) return; getPriceDetails(root).forEach(bindCover); };

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>install(document),{once:true}); else install(document);
  document.addEventListener('shopify:section:load',(event)=>install(event.target||document));
  document.addEventListener('watchers:navigation:complete',()=>install(document));
  document.addEventListener('click',(event)=>{
    if(!isMobile()) return; const target=event.target; if(!(target instanceof Element)) return;
    if(target.closest('.mobile-facets__summary')||target.closest('.mobile-facets__open, [data-watchers-open-filter], summary[aria-controls*="FacetsWrapperMobile"]')) install(document);
  },true);
})();

(() => {
  if (window.__WATCHERS_EMPTY_FACET_RUNTIME__) return;
  window.__WATCHERS_EMPTY_FACET_RUNTIME__ = true;

  function watchersRemoveEmptyFacetRows(root = document) {
    root.querySelectorAll('.mobile-facets__details').forEach((details) => {
      if (details.classList.contains('watchers-price-facet')) return;

      const summary = details.querySelector(':scope > .mobile-facets__summary');
      if (!summary) return;

      const visibleText = (summary.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();

      const hasMeaningfulControl = details.querySelector(
        'input, select, .mobile-facets__list li, .facets__price, .mobile-facets__price'
      );

      if (!visibleText && !hasMeaningfulControl) {
        details.classList.add('watchers-empty-facet-row');
      } else {
        details.classList.remove('watchers-empty-facet-row');
      }
    });

    /* Extra safeguard for the specific blank row immediately after PRICE. */
    root.querySelectorAll('.watchers-price-facet').forEach((priceDetails) => {
      let next = priceDetails.nextElementSibling;
      while (next && next.nodeType === 1) {
        if (!next.matches('.mobile-facets__details')) break;

        const summary = next.querySelector(':scope > .mobile-facets__summary');
        const text = (summary?.textContent || '').replace(/\s+/g, ' ').trim();
        const controls = next.querySelector(
          'input, select, .mobile-facets__list li, .facets__price, .mobile-facets__price'
        );

        if (!text && !controls) {
          next.classList.add('watchers-empty-facet-row');
        }
        break;
      }
    });
  }

  const run = (root = document) => {
    requestAnimationFrame(() => watchersRemoveEmptyFacetRows(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(), { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', (event) => run(event.target));

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (
          node.matches?.('.mobile-facets__details, #main-collection-filters') ||
          node.querySelector?.('.mobile-facets__details')
        ) {
          run(node);
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
